import { Link } from "react-router-dom"

import { Grid } from "@mui/material"
import { Skeleton, Tooltip, Typography } from "@synapse-analytics/synapse-ui"

import styles from "./ValueBlock.module.scss"

type Props = {
  value: string | null
  size: number
  isLoading?: boolean
  showTooltip?: boolean
  link?: string
}

export function ValueBlock(props: Readonly<Props>): React.ReactElement {
  const { isLoading, value, size, showTooltip = true, link } = props

  if (link) {
    return (
      <Grid
        item
        xs={size}
        className="card-field"
        alignItems={"center"}
        display={"flex"}
        justifyContent={"center"}
        key={link}
      >
        <Tooltip title={!isLoading && showTooltip ? value : ""} placement="top" width={"100%"}>
          <Link to={link} className={styles.name}>
            <Typography
              style={{ textAlign: "center" }}
              className={styles.name}
              color="important"
              variantColor={2}
              variant="label-bold"
            >
              {isLoading ? <Skeleton variant="rectangular" width={150} height={20} /> : value}
            </Typography>
          </Link>
        </Tooltip>
      </Grid>
    )
  }

  return (
    <Grid item xs={size} className="card-field" alignItems={"center"} display={"flex"} justifyContent={"center"}>
      <Tooltip title={!isLoading && showTooltip ? value : ""} placement="top" width={"100%"}>
        <Typography style={{ textAlign: "center" }} variant="label-bold">
          {isLoading ? <Skeleton variant="rectangular" width={150} height={20} /> : value}
        </Typography>
      </Tooltip>
    </Grid>
  )
}
